import { CriteriaRowModel } from "../../../types/bulkEmails/CriteriaRowModel";
import { CriteriaOption } from "../../../types/bulkEmails/CriteriaOption";
import { useCallback } from "react";

export const useDependenciesResolver = (options: CriteriaOption[]) => {
  const isDependenciesMet = useCallback((option: CriteriaOption, usedOptions: CriteriaRowModel[]) => {
    return (
      !option ||
      option.dependencies === undefined ||
      Object.entries(option.dependencies).every(([key, expectedValue]) => {
        return usedOptions.some((u) => u.optionKey === key && u.value === expectedValue);
      })
    );
  }, []);

  const removeUnsatisfiedRows = useCallback(
    (list: CriteriaRowModel[]): CriteriaRowModel[] => {
      let current = list;

      while (true) {
        const used = current.filter((x) => x.optionKey);
        const next = current.filter((row) => {
          const option = options.find((o) => o.key === row.optionKey);
          return isDependenciesMet(option!, used);
        });

        if (next.length === current.length) {
          return next;
        }

        current = next;
      }
    },
    [isDependenciesMet, options]
  );

  return { isDependenciesMet, removeUnsatisfiedRows };
};
